var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "event-row",
        on: {
          click: function($event) {
            _vm.setExpandId(_vm.item.id)
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.eventName.size != 0
                  ? _vm.getColumnWidth.eventName.size + "px"
                  : "12%"
            }
          },
          [
            _c("div", { staticClass: "content column-name" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("div", { staticClass: "client-name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.item.clientName) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "event-name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.item.eventName) +
                      "\n          "
                  )
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.projPart.size != 0
                  ? _vm.getColumnWidth.projPart.size + "px"
                  : "6%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.projPart) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.fullAddress.size != 0
                  ? _vm.getColumnWidth.fullAddress.size + "px"
                  : "26%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.fullAddress) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.eventLocation.size != 0
                  ? _vm.getColumnWidth.eventLocation.size + "px"
                  : "8%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.eventLocation) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.startTime.size != 0
                  ? _vm.getColumnWidth.startTime.size + "px"
                  : "7%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.startTime) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.duration.size != 0
                  ? _vm.getColumnWidth.duration.size + "px"
                  : "5%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.duration) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.endTime.size != 0
                  ? _vm.getColumnWidth.endTime.size + "px"
                  : "7%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.endTime) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.timeZone.size != 0
                  ? _vm.getColumnWidth.timeZone.size + "px"
                  : "4%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.timeZone) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.contactName.size != 0
                  ? _vm.getColumnWidth.contactName.size + "px"
                  : "9%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.contactName))
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column",
            style: {
              width:
                _vm.getColumnWidth.prefDate.size != 0
                  ? _vm.getColumnWidth.action.size + "px"
                  : "11%"
            }
          },
          [
            _c("div", { staticClass: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.item.prefDate) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-func" },
          [
            _c("Icon", {
              staticClass: "icon-btn-func",
              attrs: { name: "ellipsis-v" }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "displayNone",
        class: { openContent: _vm.item.id == _vm.getId }
      },
      [
        _c("div", { staticClass: "dt-row-item-detail" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "item-detail-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-3" }, [
                _vm.item.isChangeOrder
                  ? _c("div", { staticClass: "row li-red" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-1 icon-alert" },
                        [
                          _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle circle-red",
                            attrs: { name: "exclamation-circle" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(2)
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.projPart < 33
                  ? _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-1 icon-alert" },
                        [
                          _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle",
                            attrs: { name: "exclamation-circle" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(3)
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.projPart > 200
                  ? _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-1 icon-alert" },
                        [
                          _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle",
                            attrs: { name: "exclamation-circle" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(4)
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.disableIconContact
                  ? _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-1 icon-alert" },
                        [
                          _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle",
                            attrs: { name: "exclamation-circle" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(5)
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.enableIconDuration
                  ? _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-1 icon-alert" },
                        [
                          _c("Icon", {
                            staticClass:
                              "row-detail-icon row-detail-icon-exclamation-circle",
                            attrs: { name: "exclamation-circle" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(6)
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-4" }, [
                _c("div", { staticClass: "notes-field" }, [
                  _vm._m(7),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-value" },
                    [
                      _c("vue-google-autocomplete", {
                        attrs: {
                          name: "shipping-address",
                          id: "shipping_" + _vm.index,
                          classname: "additional-comments shipping-address",
                          country: ["us"],
                          item: _vm.item,
                          disabled: !_vm.editable
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "notes-field" }, [
                  _c("div", { staticClass: "text-label" }, [
                    _vm._v(
                      "\n                  Additional comments\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-value" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.additionalComments,
                          expression: "item.additionalComments"
                        }
                      ],
                      staticClass: "additional-comments",
                      attrs: {
                        name: "additional-comments",
                        disabled: !_vm.editable
                      },
                      domProps: { value: _vm.item.additionalComments },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.item,
                            "additionalComments",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3" }, [
                _c("div", { staticClass: "text-contact grey-3" }, [
                  _c("div", { staticClass: "label" }, [_vm._v("Name")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "contactName" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.contactName,
                          expression: "item.contactName"
                        }
                      ],
                      staticClass: "phoneAndEmail",
                      attrs: {
                        placeholder: "Contact name",
                        disabled: !_vm.editable
                      },
                      domProps: { value: _vm.item.contactName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "contactName", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-contact grey-3" }, [
                  _c("div", { staticClass: "label" }, [_vm._v("Email")]),
                  _vm._v(" "),
                  _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.email,
                          expression: "item.email"
                        }
                      ],
                      staticClass: "phoneAndEmail",
                      attrs: {
                        placeholder: "E.g. hannah_welch@gmail.com",
                        disabled: !_vm.editable
                      },
                      domProps: { value: _vm.item.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "email", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-contact grey-3" },
                  [
                    _c("div", { staticClass: "label" }, [_vm._v("Phone")]),
                    _vm._v(" "),
                    _c("the-mask", {
                      staticClass: "phoneAndEmail",
                      attrs: {
                        mask: "(###) ###-####",
                        masked: _vm.isTrue,
                        placeholder: "(123) 123-1234",
                        disabled: !_vm.editable
                      },
                      model: {
                        value: _vm.item.phone,
                        callback: function($$v) {
                          _vm.$set(_vm.item, "phone", $$v)
                        },
                        expression: "item.phone"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "add-on-wrapper col-sm-2" },
                _vm._l(_vm.item.additionalServices, function(itemAddOn, index) {
                  return _c("div", { key: index, staticClass: "add-on-item" }, [
                    _c("div", {}, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: itemAddOn.value,
                            expression: "itemAddOn.value"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          id: itemAddOn.key + "_" + _vm.item.id,
                          disabled: _vm.disableAdditionalServices
                        },
                        domProps: {
                          checked: Array.isArray(itemAddOn.value)
                            ? _vm._i(itemAddOn.value, null) > -1
                            : itemAddOn.value
                        },
                        on: {
                          change: function($event) {
                            var $$a = itemAddOn.value,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    itemAddOn,
                                    "value",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    itemAddOn,
                                    "value",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(itemAddOn, "value", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          class: { "add-on-off-checkbox": !itemAddOn.isShow },
                          attrs: { for: itemAddOn.key + "_" + _vm.item.id }
                        },
                        [_vm._v("Toggle")]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text",
                        class: { "add-on-off-text": !itemAddOn.isShow }
                      },
                      [_vm._v(_vm._s(itemAddOn.text))]
                    )
                  ])
                })
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "func-group" },
              [
                _c("DataTableGroupBtn", {
                  attrs: {
                    isLocked: _vm.isLocked,
                    showOnModal: _vm.showOnModal,
                    editEventAdmin: _vm.editEventAdmin,
                    viewMode: _vm.viewMode,
                    eventStatus: _vm.eventStatus,
                    item: _vm.item,
                    isSuggestChanges: _vm.suggestChanges
                  }
                })
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-status" }, [
      _c("div", { staticClass: "calendar-checked-icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-detail-header" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-3 padding-left-71 padding-top-9px" }, [
          _vm._v("alerts")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-4 padding-left-27 padding-top-9px" }, [
          _vm._v("event notes")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-3 padding-top-9px" }, [
          _vm._v("on site contact")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-2 padding-top-9px" }, [
          _vm._v("add on services")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-11 text-alert" }, [
      _c("span", { staticClass: "alert-note" }, [
        _vm._v(
          "This item approved as a change order. Check change notes and contract details."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-11 text-alert" }, [
      _c("span", { staticClass: "alert-note" }, [
        _vm._v(
          "Your estimated participation is low. Consider using small site event."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-11 text-alert" }, [
      _c("span", { staticClass: "alert-note" }, [
        _vm._v("Your estimated participation is high. Break event into 2 days.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-11 text-alert" }, [
      _c("span", { staticClass: "alert-note" }, [
        _vm._v(
          "Missing (email, phone number, email and phone number) for on site contact."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-11 text-alert" }, [
      _c("span", { staticClass: "alert-note" }, [
        _vm._v(
          "Standard events can only be submitted with durations between 4 - 8 hours. To request an event outside of this range please contact ADURO."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-label" }, [
      _vm._v("\n                  shipping address\n                  "),
      _c("span", { staticClass: "grey-3 label-address" }, [
        _vm._v("(if different)")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-633b0795", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-633b0795","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatable/EventRow.vue
// module id = 1777
// module chunks = 1